import { customizePin } from './customPin';
import operationsLeasePin from '../../assets/layer-pins/pin-operations-lease-cluster-custom.svg?raw';
import thirdPartyPinRaw from '../../assets/layer-pins/pin-operations-3rdparty-lease-cluster-custom.svg?raw';
import directOperatedPinRaw from '../../assets/layer-pins/pin-operations-directmanaged-cluster-custom.svg?raw';
import { propertyColors } from '../../utils/constants';

/**
 * Returns an SVG data URL for the lease (FRI-leased) property pin using the configured lease color.
 */
export function getLeasePin() {
  return customizePin({ bgColor: propertyColors.lease, pin: operationsLeasePin });
}
/**
 * Returns an SVG data URL for the third-party/contract-managed property pin.
 */
export function getThirdPartyPin() {
  return customizePin({ bgColor: propertyColors.contractManaged, pin: thirdPartyPinRaw });
}
/**
 * Returns an SVG data URL for the investment/acquisition property pin using the investment color.
 */
export function getInvestmentPin() {
  return customizePin({ bgColor: propertyColors.investment, pin: thirdPartyPinRaw });
}
/**
 * Returns an SVG data URL for the 'other' (catch-all) property pin.
 */
export function getOtherPin() {
  return customizePin({ bgColor: propertyColors.other, pin: thirdPartyPinRaw });
}
/**
 * Returns an SVG data URL for the FRI-directly-operated property pin using the configured direct operations color.
 */
export function getDirectOperatedPin() {
  return customizePin({ bgColor: propertyColors.directOperations, pin: directOperatedPinRaw });
}

/**
 * Returns an SVG data URL for the PRI property pin using the configured PRI color.
 */
export function getPRIPin(){
  return customizePin({bgColor: propertyColors.pri, pin: thirdPartyPinRaw})
}

/**
 * Returns an SVG data URL for the gray `Unknown` `MgmtType` pin — used when a
 * layer-14 boundary feature has a null, blank, or unexpected `MgmtType`
 * value. Must remain visually distinct from the Contractor Managed pin and
 * must never imply an authorized/unauthorized status.
 */
export function getUnknownMgmtTypePin() {
  return customizePin({ bgColor: propertyColors.unknownMgmtType, pin: thirdPartyPinRaw });
}

/**
 * Returns an SVG data URL for an unclustered acquisition pin colored by the
 * acquisition phase/status preset's per-category color (PRM-151). Uses the
 * same base pin template as the default investment pin (`getInvestmentPin`)
 * so switching the Style preset changes only color, not shape.
 *
 * @param bgColor - The category color to fill the pin with (from `acquisitionStatusPreset`).
 */
export function getAcquisitionStatusPin(bgColor: string) {
  return customizePin({ bgColor, pin: thirdPartyPinRaw });
}